<template>
  <v-container fluid>
    <div class="d-flex flex-column">
      <v-form ref="form" v-model="valid">
        <v-text-field
          v-model="userId"
          :rules="nameRules"
          label="Utilisateur"
          required
        ></v-text-field>
        <v-text-field
          v-model="password"
          :rules="nameRules"
          label="Mot de passe"
          type="password"
          required
        ></v-text-field>
        <v-btn :disabled="!valid" color="success" @click="validate">
          Se connecter
        </v-btn>
        <div v-if="errors.length">
          <b>Erreur(s) :</b>
          <ul>
            <li v-for="error in errors" :key="error">{{ error }}</li>
          </ul>
        </div>
        <div v-if="status">
          <b>Status :</b> {{ status }}
        </div>
      </v-form>
    </div>
  </v-container>
</template>

<script>
export default {
  props: ['nextUrl'],
  data () {
    return {
      valid: true,
      userId: null,
      status: null,
      password: null,
      nameRules: [v => !!v || 'Champ requis'],
      errors: []
    }
  },
  methods: {
    validate () {
      this.$refs.form.validate().then(valid => {
        if (!valid) return
        this.errors = []
        this.$apiclient.signin(this.userId, this.password)
          .then(response => {
            if (response.status !== 200) {
              this.errors.push(response.statusText)
              return
            }
            this.status = 'connecté'
            this.valid = false
            if (this.$route.query.nextUrl != null) {
              this.$router.push(this.$route.query.nextUrl)
            }
          })
          .catch(error => {
            if (error.response.status === 401) {
              this.errors.push(error.response.data)
            } else {
              this.errors.push(error.response.statusText)
            }
          })
      })
    }
  }
}
</script>
